import React from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import TextNumber from 'components/text/TextNumber';

const InputNumber = ({name,value,onChange,onFocus,onBlur,placeholder,label,allowNegative,disabled,error,useIconError,decimalScale, min = null, max = null}) => {
  const handleChange = (values, e) => {
    if (typeof onChange === 'function') { 
      if (values.value != ""){   
        let num = Number(values.value);      
        if (min){ //Check for min
          if (num < min) num = min;          
        }
        if (max){  //Check for max
          if (num > max) num = max;
        }
        onChange(num);
      }     
      else{
        onChange(null);
      }
    }
  };

  const handleFocus = e => {
    if (typeof onFocus === 'function') {
      onFocus(e.target.value);
    }
  };

  const handleBlur = e => {
    if (typeof onBlur === 'function') {
      onBlur(e.target.value);
    }
  };

  let _id = name + '_' + Math.floor(Math.random() * Math.floor(5000));
  const _label = label ? <label htmlFor={_id}>{label}</label> : '';

  if (disabled){
    return <TextNumber value={value} />
  }

  const inp = (
    <React.Fragment>
      {_label}
      <NumberFormat
        id={_id}        
        value={value}        
        onValueChange={(values, e) => handleChange(values, e)}
        onFocus={handleFocus}
        onBlur={handleBlur}
        decimalSeparator=","
        thousandSeparator=""        
        allowNegative={allowNegative}
        placeholder={placeholder}
        displayType={disabled}
        decimalScale={decimalScale}
      />
    </React.Fragment>
  );

  let inputContainer;
  if (!error || error === '') {
    inputContainer = inp;
  } else {
    if (useIconError) {
      inputContainer = (
        <div className="input-icon">
          {inp}
          {error !== '' && <i className="icon-alert" />}
        </div>
      );
    } else {
      inputContainer = (
        <div>
          {inp}
          <p className="small text-red">{error}</p>
        </div>
      );
    }
  }

  return inputContainer;
};

InputNumber.defaultProps = {
  allowNegative: false,
  disabled: false,
  useIconError: false,
  decimalScale: 0
};

InputNumber.propTypes = {
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  placeholder: PropTypes.string,
  maxLength: PropTypes.string,
  disabled: PropTypes.bool,
  allowNegative: PropTypes.bool,
  error: PropTypes.string,
  useIconError: PropTypes.bool,
  decimalScale: PropTypes.number
};

export default InputNumber;
